import Cookies from "universal-cookie";

// export const CID = "cid";
export const UserPass = "up";
export const BLAUTHTOKEN = "AuthToken";
export const LOGINTOKEN = "loginToken";
export const TEMPLATE_ID = "templateId";
export const AUDIO_VOLUME = "audio_volume";
export const CURRENCY_CODE = "currency_code";

export const setDataInStore = (key, value) => {
    if (key === null || key === undefined || key === 'undefined') return;
    if (value === null || value === undefined || value === 'undefined') return;
    const cookies = new Cookies();
    var expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + 30);
    cookies.set(key, value, { path: "/", expires: expireDate });
    localStorage.setItem(key, JSON.stringify(value));
    return value;
};

export const getDataFromStore = (key) => {
    const cookies = new Cookies();
    if (cookies.get(key) !== null && cookies.get(key) !== undefined) {
        return cookies.get(key);
    }
    var value = localStorage.getItem(key);
    if (value !== null && value !== undefined && value !== "undefined") {
        return JSON.parse(value);
    }
    return null;
};

export const deleteDataFromStore = (key) => {
    const cookies = new Cookies();
    cookies.remove(key);
    localStorage.removeItem(key);
};

export const clearDataFromStore = () => {
    const cookies = new Cookies();
    cookies.remove();
    localStorage.clear();
};

export const getAudioVolume = () => {
    let audioVolume = getDataFromStore(AUDIO_VOLUME);
    if(audioVolume === null || audioVolume === undefined) {
        audioVolume = {
            "volume" : 1.0
        };
        setDataInStore(AUDIO_VOLUME, audioVolume);
    }
    return audioVolume.volume;
};

export const setAudioVolume = (volume) => {
    let audioVolume = {
        "volume": volume
    };
    setDataInStore(AUDIO_VOLUME, audioVolume);
};